<mat-checkbox color="primary" [formControl]="inputControl">{{ label }}</mat-checkbox>
